<template>
  <NuxtLayout>
    <NuxtPwaManifest />
    <NuxtPage />
    <reusable-notification v-if="notificationConfig" v-model="notificationShown" :config="notificationConfig" />
    <reusable-prompt v-for="prompt in promptQueue" :key="prompt.id" v-bind="prompt" />
  </NuxtLayout>
</template>

<script lang="ts" setup>
useSecurityStore()
useSettingsStore()
useThemeStore()
const { $eventBus } = useNuxtApp()
const { promptQueue, notificationShown, notificationConfig } = $eventBus
</script>
